var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon3DCube = function SvgIcon3DCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 20.058a1 1 0 0 1-1 0l-5.928-3.423a1 1 0 0 1-.5-.866V8.924a1 1 0 0 1 .5-.866L11.5 4.635a1 1 0 0 1 1 0l5.928 3.423a1 1 0 0 1 .5.866v6.845a1 1 0 0 1-.5.866zm-6.428-4.29 5.428 3.135v-6.27L6.072 9.466zm.53-7.15L12 5.5l5.399 3.117L12 11.767zm11.326.849L12.5 12.633v6.27l5.428-3.134z",
    clipRule: "evenodd"
  })));
};
export default SvgIcon3DCube;